var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWageMoney = function SvgWageMoney(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 80",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.97 23.29l-.032 23.89 12.82.019.033-23.89-12.82-.018z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M37.752 19.225l-.033 23.89 12.82.018.033-23.89-12.82-.018z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M45.37 23.74a.973.973 0 01.315.044 1.138 1.138 0 00-.148-.02l-.102-.003a1.054 1.054 0 00-.854.39c.028-.041.055-.08.084-.113.156-.182.357-.286.704-.298z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25.292 27.19h27.41c1.49 0 2.7 1.21 2.7 2.7v25.48c0 1.49-1.21 2.7-2.7 2.7h-27.41V27.19z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56.486 39.59h-13.34v6.05h13.34v-6.05z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M46.423 41.21c.738.001 1.36.62 1.36 1.411s-.622 1.41-1.36 1.41c-.739 0-1.36-.619-1.36-1.41 0-.791.621-1.41 1.36-1.41z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWageMoney);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wage-money.05df265ce9e4526b9bd49362cf881b44.svg";